import './overlay/index.js'
import Producer from './studio/Producer.js'

window.studio = new Producer(document.querySelector('#gl'))

if (import.meta.hot) {
    import.meta.hot.dispose(() => {
        return window.studio?.dispose()
    })
}
